import {map} from 'lodash/fp';
import {alliances, airlines} from 'helpers/stableValues';

const groupedAirlineOptions = {
  alliances: map.convert({cap: false})((name, code) => ({code, name}), alliances),
  airlines: map.convert({cap: false})((name, code) => ({code, name}), airlines)
};

export default groupedAirlineOptions;
